module.exports = [{"spsr":"none","company":"none","link":"/about#sponsors","logo":"./public/logos/none.svg","title":"Like this word?","subtitle":"Support this project and sponsor this word."},{"spsr":"monday","company":"Monday.com","link":"https://monday.com/?ref=letsseeco&utm_source=letsseeco","logo":"./public/logos/monday.svg","title":"A project management tool built for teamwork","subtitle":"Plan, manage and track even the most complex projects. Collaborate and communicate with your team in one place."}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/spsr.json
// module id = 2WQE
// module chunks = 0